/**
 * Search API Service
 * 
 * Global Search (nicht Library-spezifisch)
 * 
 * Endpoints:
 * GET /search/mangas?q=&cursor=&limit= - Globale Manga-Suche
 */

import { get, buildCursorParams } from '../client';

/**
 * Globale Manga-Suche
 * @param {string} query - Suchbegriff
 * @param {object} options - { cursor?, limit? }
 * @returns {Promise<{success: boolean, data?: {items: SearchResult[], next_cursor: string|null}, error?: object}>}
 * 
 * Response Item:
 * {
 *   manga_id: number,
 *   title: string,
 *   publisher: string,
 *   status: string,
 *   cover_media_key: string
 * }
 */
export const searchMangas = async (query, options = {}) => {
  const params = {
    q: query,
    ...buildCursorParams({ ...options, limit: options.limit || 50 }),
  };
  return get('/search/mangas', params);
};

/**
 * Globale Suche mit allen Ergebnissen (Cursor-Following)
 * @param {string} query - Suchbegriff
 * @param {number} maxLimit - Maximale Anzahl (default: 500)
 * @returns {Promise<{success: boolean, items?: SearchResult[], error?: object}>}
 */
export const searchAllMangas = async (query, maxLimit = 500) => {
  const allItems = [];
  let cursor = null;
  
  while (allItems.length < maxLimit) {
    const result = await searchMangas(query, { cursor, limit: 50 });
    
    if (!result.success) {
      return result;
    }
    
    const items = result.data?.items || [];
    allItems.push(...items);
    
    cursor = result.data?.next_cursor;
    if (!cursor || items.length === 0) {
      break;
    }
  }
  
  return { success: true, items: allItems };
};

// ============================================================================
// TYPES (JSDoc)
// ============================================================================

/**
 * @typedef {object} SearchResult
 * @property {number} manga_id
 * @property {string} title
 * @property {string} publisher
 * @property {string} status
 * @property {string} cover_media_key
 */
